import * as React from 'react';
import Stack from '@mui/material/Stack';
import NavbarBreadcrumbs from './NavbarBreadcrumbs';
import ColorModeIconDropdown from './ColorModeIconDropdown';
import { useFeatureFlag, FEATURE_FLAGS } from '../contexts/FeatureFlagContext';

export default function Header() {
  const { enabled: themeToggleEnabled } = useFeatureFlag(
    FEATURE_FLAGS.ENABLE_THEME_TOGGLE
  );

  return (
    <Stack
      direction="row"
      sx={{
        display: { xs: 'none', md: 'flex' },
        width: '100%',
        alignItems: { xs: 'flex-start', md: 'center' },
        justifyContent: 'space-between',
        maxWidth: { sm: '100%', md: '1700px' },
        pt: 1.5,
      }}
      spacing={2}
    >
      <NavbarBreadcrumbs />
      <Stack direction="row" sx={{ gap: 1 }}>
        {themeToggleEnabled && <ColorModeIconDropdown />}
      </Stack>
    </Stack>
  );
}
